<template>
	<div class="col-sm-7" :class="'image_container_' + attributeName">
		<template v-if="lockedEdit">
			<input type="text" class="image-drop-zone" :disabled="lockedEdit" />
		</template>
		<template v-else>
			<input class="image-uploader" :id="attributeName + '_uploader'" type="file" :accept="type" multiple>
			<div :id="attributeName + '__drop-zone'" class="image-drop-zone"></div>
			<ul :id="attributeName + '__error-block'" class="image-error-block hidden-element"></ul>
			<progress></progress>
			<div :id="attributeName + '__image__area'" max-count="-1">
				<div class="row" :class="'drag_wrapper_' + attributeName" :ref="'drag_wrapper_' + attributeName"
					 @dragstart="handleDragStart" @dragend="handleDragStop" @dragover="handleDragOver"
					 @drop="handleDrop">
					<div draggable="true" data-attribute-type="single" :class="'drag_item_' + attributeName"
						 v-for="(value, key) in attributeDataObj" :data-attribute-index="key" :key="value.id">
						<div v-if="value !== ''" :class="SINGLE_ATTRIBUTE + ' image-attribute-container'">
							<div class="move">
								<span class="button_minus fa fa-arrows-v"></span>
							</div>
							<img draggable="false"
								 v-if="value.extension === 'png' || value.extension === 'jpg' || value.extension === 'jpeg'"
								 :id="attributeName + '__image__' + key" :src="srcImg(value.id)"
								 @click="getImg(value.id)" :alt="value.filename" class="image-attribute">
							<p draggable="false" v-else class="file-preview uk-link image-attribute"
							   :src="srcImg(value.id)" :id="attributeName + '__image__' + key"
							   @click="getImg(value.id)">{{ value.filename }}</p>
							<button draggable="false" class="button_minus fa fa-minus" @click="deleteImg"></button>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import { Fragment } from 'vue-fragment'
import defaultClassManager from '../../mixins/defaultClassManager'
import { bindImageAttributeEvents } from '@/core/input_controls/fileUploader/imageUploader'
import { deleteComponent, updateElementIndex } from '@/core/item_assistance/creatingNewComponents'
import http from 'utils/http'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'

export default {
	name: 'ImgAttributeEditorComponent',
	props: [
		'attributeName',
		'localizedTitle',
		'isPrimary',
		'colspan',
		'itemData',
		'lockedEdit'
	],
	mixins: [defaultClassManager],
	components: {
		AttributeLabel,
		Fragment
	},
	data () {
		return {
			SINGLE_ATTRIBUTE: 'single-attribute',
			type: '*/*',
			attributeDataObj: [],
			loaded: false
		}
	},
	computed: {
		attributeData: {
			get () {
				return this.itemData || []
			},
			async set (value) {
				this.attributeDataObj = await this.initData(value)
			}
		}
	},
	watch: {
		itemData: async function (newValue) {
			this.attributeDataObj = await this.initData(newValue)
		}
	},
	methods: {
		srcImg: function (value) {
			return window.urlContext + 'attachment?id=' + value + '&token=' + localStorage.getItem('user-token')
		},
		getImg: function (value) {
			location.href = this.srcImg(value)
		},
		deleteImg: async function (e) {
			let selectorImageArea = $('#' + this.attributeName + '__image__area')
			let key = $(e.target).parent().parent().attr('data-attribute-index')
			deleteComponent(selectorImageArea, selectorImageArea.find('div[data-attribute-index=' + key + ']').eq(0), 'image')
			this.attributeData.splice(key, 1)
			this.attributeDataObj = await this.initData(this.attributeData)
		},
		async initData (value) {
			let attributeData = []

			if (value && value.length > 0) {
				for (let id of value) {
					await http.get(`/attachment/${id}/metadata`).then(resp => {
						attributeData.push({
							id: id,
							filename: resp.data.filename,
							extension: resp.data.extension
						})
					}).catch(() => {
            attributeData = [{
              id,
              filename: 'image.not.found',
              extension: ''
            }]
          })
				}
			}
			return attributeData
		},
		handleDragStart (event) {
			event.target.classList.add('selected')
		},
		handleDragStop (event) {
			event.target.classList.remove('selected')
		},
		getNextElement: (cursorPosition, currentElement) => {
			const currentElementCoord = currentElement.getBoundingClientRect();
			const currentElementCenter = currentElementCoord.y + currentElementCoord.height / 2;

			const nextElement = (cursorPosition < currentElementCenter) ?
				currentElement :
				currentElement.nextElementSibling;

			return nextElement;
		},
		handleDragOver (event) {
			event.preventDefault()

			const dragWrapper = '.drag_wrapper_' + this.attributeName
			const dragItem = '.drag_item_' + this.attributeName
			const tasksListElement = document.querySelector(dragWrapper)
			const taskElements = tasksListElement.querySelectorAll(dragItem)
			const activeElement = tasksListElement.querySelector('.selected')
			const currentElement = event.target.closest(dragItem)

			const isMoveable = activeElement !== currentElement

			if (!isMoveable) {
				return false
			}

			const nextElement = this.getNextElement(event.clientY, currentElement)

			if (
				nextElement &&
				activeElement === nextElement.previousElementSibling ||
				activeElement === nextElement
			) {
				return false
			}

			tasksListElement.insertBefore(activeElement, nextElement)
		},
		handleDrop () {
			let selectorImageArea = $('#' + this.attributeName + '__image__area')
			let id = $(selectorImageArea).attr('id').substring(0, $(selectorImageArea).attr('id').length - 6)

			this.$refs['drag_wrapper_' + this.attributeName].querySelectorAll('div[data-attribute-index]').forEach((element, index) => {
				updateElementIndex($(element), index, id)
			})
			attributeChangesRegister(this.attributeName)
		}
	},
	updated () {
		if (this.loaded) {
			attributeChangesRegister(this.attributeName)
		}
	},
	async mounted () {
		if (!this.lockedEdit) {
			bindImageAttributeEvents(this.attributeName, this)
			this.attributeDataObj = await this.initData(this.itemData)
		}
	}
}
</script>

<style scoped>
	.file-preview {
		display: inline-block;
		word-break: break-all;
		padding: 5px;
	}
	.file-preview:hover {
		cursor: pointer;
		text-decoration: underline;
	}
	.upload-template {
		display: inline-block;
	}
	.upload-template .single-attribute {
		max-width: 185px;
	}
	.move {
		position: absolute;
		top: 5px;
		left: -23px;
		height: 70%;
		width: 23px;
		cursor: move;
	}
	.move span {
		cursor: move;
		padding: 0 0 0 9px;
	}
	.selected {
		background-color: #f6f6f6;
	}
	progress {
		display: none;
		width: 100%;
		height: 7px;
	}
</style>
